import { Injectable } from '@angular/core';

@Injectable()
export class AboutUsCommon {
	
	constructor(
		
	) {

	}

	public commonMethod(){
		console.log("Hello");
	}
}



// WEBPACK FOOTER //
// ./src/modules/about-us/pages/about-us/about-us.common.ts